// extracted by mini-css-extract-plugin
export default {"link":"jJ-z","disabled":"kJ-z"};